import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { GlobalNavigationEmpty } from 'site-modules/shared/components/global-navigation-v2/global-navigation-empty';
import { Footer } from 'site-modules/shared/components/footer/footer';
import { FloodlightAd } from 'site-modules/shared/components/floodlight/floodlight-ad';
import { SEOHead } from 'site-modules/shared/pages/seo';
import { FeatureFlag } from 'site-modules/shared/components/feature-flag/feature-flag';
import { SpaLinks } from 'site-modules/shared/components/spa-links/spa-links';
import { ProfileContextAsync } from 'site-modules/shared/components/profile/profile-context-async';
import { ExperimentsPanel } from 'site-modules/shared/components/experiment/panel/experiments-panel';
import { AdsContext } from 'site-modules/shared/components/ads-context/ads-context';
import { ClientSideRender } from 'site-modules/shared/components/client-side-render/client-side-render';
import { ErrorBoundary } from 'site-modules/shared/components/error-boundary/error-boundary';
import { ErrorPageMessage } from 'site-modules/shared/components/error-page-message/error-page-message';
import { PubpixelAd } from 'site-modules/shared/components/pubpixel/pubpixel-ad';
import { ModelPreloader } from 'client/data/luckdragon/redux/model-preloader';
import { VisitorModel } from 'client/data/models/visitor';

export class EdmundsLandingDecorator extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    skipFooter: PropTypes.bool,
  };

  static preload(store) {
    const preloader = new ModelPreloader(store);
    preloader.resolve('rttSegment', VisitorModel);
    return preloader.load();
  }

  render() {
    return (
      <div className={classnames('edm-page has-global-nav', this.props.className)}>
        <ErrorBoundary>
          <GlobalNavigationEmpty />
        </ErrorBoundary>
        <ErrorBoundary>
          <SEOHead {...this.props} />
        </ErrorBoundary>
        <ErrorBoundary>
          <FeatureFlag name="testSpa">
            <SpaLinks />
          </FeatureFlag>
        </ErrorBoundary>
        <ErrorBoundary Fallback={ErrorPageMessage}>{this.props.children}</ErrorBoundary>
        {!this.props.skipFooter && (
          <ErrorBoundary>
            <Footer />
          </ErrorBoundary>
        )}
        <ErrorBoundary>
          <FeatureFlag name="ads">
            <ErrorBoundary>
              <PubpixelAd />
            </ErrorBoundary>
            <ErrorBoundary>
              <FloodlightAd />
            </ErrorBoundary>
            <ErrorBoundary>
              <AdsContext />
            </ErrorBoundary>
          </FeatureFlag>
        </ErrorBoundary>
        <ErrorBoundary>
          <ClientSideRender>
            <ProfileContextAsync />
          </ClientSideRender>
        </ErrorBoundary>
        <ErrorBoundary>
          <ClientSideRender>
            <ExperimentsPanel />
          </ClientSideRender>
        </ErrorBoundary>
      </div>
    );
  }
}
